/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StateStep } from './StateStep';
import {
    StateStepFromJSON,
    StateStepFromJSONTyped,
    StateStepToJSON,
    StateStepToJSONTyped,
} from './StateStep';
import type { DataImportStatusEnum } from './DataImportStatusEnum';
import {
    DataImportStatusEnumFromJSON,
    DataImportStatusEnumFromJSONTyped,
    DataImportStatusEnumToJSON,
    DataImportStatusEnumToJSONTyped,
} from './DataImportStatusEnum';
import type { ImportTypeEnum } from './ImportTypeEnum';
import {
    ImportTypeEnumFromJSON,
    ImportTypeEnumFromJSONTyped,
    ImportTypeEnumToJSON,
    ImportTypeEnumToJSONTyped,
} from './ImportTypeEnum';
import type { ActionStatusEnum } from './ActionStatusEnum';
import {
    ActionStatusEnumFromJSON,
    ActionStatusEnumFromJSONTyped,
    ActionStatusEnumToJSON,
    ActionStatusEnumToJSONTyped,
} from './ActionStatusEnum';

/**
 * A data import with its errors and every step its state machine went through.
 * @export
 * @interface DataImportDetail
 */
export interface DataImportDetail {
    /**
     * 
     * @type {string}
     * @memberof DataImportDetail
     */
    readonly id: string;
    /**
     * 
     * @type {ImportTypeEnum}
     * @memberof DataImportDetail
     */
    readonly importType: ImportTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof DataImportDetail
     */
    readonly importParams: any | null;
    /**
     * 
     * @type {DataImportStatusEnum}
     * @memberof DataImportDetail
     */
    readonly status: DataImportStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof DataImportDetail
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof DataImportDetail
     */
    readonly createdBy: number;
    /**
     * 
     * @type {string}
     * @memberof DataImportDetail
     */
    readonly createdByEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof DataImportDetail
     */
    readonly updatedAt: Date | null;
    /**
     * 
     * @type {any}
     * @memberof DataImportDetail
     */
    readonly importErrors: any | null;
    /**
     * The current state, or None for imports from before the state machine.
     * @type {string}
     * @memberof DataImportDetail
     */
    readonly state: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DataImportDetail
     */
    readonly stateEnteredAt: Date | null;
    /**
     * 
     * @type {ActionStatusEnum}
     * @memberof DataImportDetail
     */
    readonly actionStatus: ActionStatusEnum;
    /**
     * 
     * @type {Array<StateStep>}
     * @memberof DataImportDetail
     */
    readonly stateHistory: Array<StateStep>;
}



/**
 * Check if a given object implements the DataImportDetail interface.
 */
export function instanceOfDataImportDetail(value: object): value is DataImportDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('importType' in (value as Record<string, any>)) && !('import_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['importType'] === undefined && (value as Record<string, any>)['import_type'] === undefined)) return false;
    if ((!('importParams' in (value as Record<string, any>)) && !('import_params' in (value as Record<string, any>))) || ((value as Record<string, any>)['importParams'] === undefined && (value as Record<string, any>)['import_params'] === undefined)) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('createdBy' in (value as Record<string, any>)) && !('created_by' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdBy'] === undefined && (value as Record<string, any>)['created_by'] === undefined)) return false;
    if ((!('createdByEmail' in (value as Record<string, any>)) && !('created_by_email' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdByEmail'] === undefined && (value as Record<string, any>)['created_by_email'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    if ((!('importErrors' in (value as Record<string, any>)) && !('import_errors' in (value as Record<string, any>))) || ((value as Record<string, any>)['importErrors'] === undefined && (value as Record<string, any>)['import_errors'] === undefined)) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if ((!('stateEnteredAt' in (value as Record<string, any>)) && !('state_entered_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['stateEnteredAt'] === undefined && (value as Record<string, any>)['state_entered_at'] === undefined)) return false;
    if ((!('actionStatus' in (value as Record<string, any>)) && !('action_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionStatus'] === undefined && (value as Record<string, any>)['action_status'] === undefined)) return false;
    if ((!('stateHistory' in (value as Record<string, any>)) && !('state_history' in (value as Record<string, any>))) || ((value as Record<string, any>)['stateHistory'] === undefined && (value as Record<string, any>)['state_history'] === undefined)) return false;
    return true;
}

export function DataImportDetailFromJSON(json: any): DataImportDetail {
    return DataImportDetailFromJSONTyped(json, false);
}

export function DataImportDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImportDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'importType': ImportTypeEnumFromJSON(json['import_type']),
        'importParams': json['import_params'],
        'status': DataImportStatusEnumFromJSON(json['status']),
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'createdBy': json['created_by'],
        'createdByEmail': json['created_by_email'],
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
        'importErrors': json['import_errors'],
        'state': json['state'],
        'stateEnteredAt': (json['state_entered_at'] == null ? null : new Date(json['state_entered_at'])),
        'actionStatus': ActionStatusEnumFromJSON(json['action_status']),
        'stateHistory': ((json['state_history'] as Array<any>).map(StateStepFromJSON)),
    };
}

export function DataImportDetailToJSON(json: any): DataImportDetail {
    return DataImportDetailToJSONTyped(json, false);
}

export function DataImportDetailToJSONTyped(value?: Omit<DataImportDetail, 'id'|'importType'|'importParams'|'status'|'createdAt'|'createdBy'|'createdByEmail'|'updatedAt'|'importErrors'|'state'|'stateEnteredAt'|'actionStatus'|'stateHistory'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

